/**
 * @author tomekbuszewski
 * @since 2019-6-12
 */

import * as React from "react";
import styled from "styled-components";

import { ITheme } from "@ui/themes/ThemeInterface";

interface Props {
  children?: React.ReactNode[];
  theme: ITheme;
  sticky?: boolean;
}

const Sidebar = styled.nav<Props>`
  list-style: none;
  position: ${props => (props.sticky ? "sticky" : "static")};
  top: ${props => props.theme.margins.base_x3};
  padding: 0;
  margin: ${props => `${props.theme.margins.base_x2} 0`};
`;

export { Sidebar };

Sidebar.displayName = "Sidebar";
